/* global $ */

/* enables native print action on a specific button */
$.$body.on('click', '.js-print', (e) => {
	e.preventDefault();
	window.print();
});
